import type { InvoicingMode } from '../types/security-admin.types';

interface InvoicingModeCopy {
  label: string;
  help: string;
}

const COPY: Record<InvoicingMode, InvoicingModeCopy> = {
  relaxed_open: {
    label: 'Relaxed Open',
    help: 'Members can invoice any product through the group dealers.',
  },
  relaxed_closed: {
    label: 'Relaxed Closed',
    help: 'Members can invoice only the products attached to the group.',
  },
  strict: {
    label: 'Strict',
    help: 'Members can view, quote, sell and invoice only the products attached to the group.',
  },
};

const EMPTY_GROUP_WARNING: Record<'relaxed_closed' | 'strict', string> = {
  relaxed_closed:
    'This group has no products attached, so its members cannot invoice any product through it until you attach some.',
  strict:
    'This group has no products attached, so its members cannot see, quote, sell or invoice any product through it until you attach some.',
};

export const INVOICING_MODE_OPTIONS: { value: InvoicingMode; label: string }[] = (
  Object.keys(COPY) as InvoicingMode[]
).map((value) => ({ value, label: COPY[value].label }));

export function invoicingModeLabel(mode: InvoicingMode): string {
  return COPY[mode].label;
}

export function invoicingModeHelp(mode: InvoicingMode): string {
  return COPY[mode].help;
}

export function invoicingModeWarning(mode: InvoicingMode, productsCount: number): string | null {
  if (mode === 'relaxed_open' || productsCount > 0) return null;
  return EMPTY_GROUP_WARNING[mode];
}
